export const ENTRY = "/";
export const SIGNIN = "/signin";
export const DASHBOARD = "/dashboard";
export const FREELANCER = "/freelancers";
export const FREELANCER_DETAIL = "/freelancers/:freelancerId";
export const CLIENT = "/clients";
export const CLIENT_DETAIL = "/clients/:clientId";
export const PROJECT = "/projects";
export const PROJECT_DETAIL = "/projects/:projectId";
export const JOB = "/jobs";
export const JOB_DETAIL = "/jobs/:jobId";
export const FINANCIAL = "/financials";
export const ANALYTICS = "/analytics";
export const SETTINGS = "/settings";
export const SETTINGS_AI = "/settings/ai";
export const FAQ = "/faqs";
export const FAQ_CREATE = "/faqs/create";
export const FAQ_EDIT = "/faqs/:id/edit";
export const FAQ_CATEGORIES = "/faq-categories";
export const SUPPORT_CONTACT_US = "/support-contact-us";
export const CAREER = "/careers";
export const CAREER_OPENINGS = "/careers/openings";
export const CAREER_OPENINGS_CREATE = "/careers/openings/create";
export const CAREER_OPENINGS_EDIT = "/careers/openings/:id/edit";
export const CAREER_APPLICATIONS = "/careers/applications";
